import { Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface DocNavLink {
  readonly title: string
  readonly url: string
}

interface DocNavProps {
  readonly prev?: DocNavLink
  readonly next?: DocNavLink
}

export function DocNav({ prev, next }: DocNavProps) {
  return (
    <nav aria-label="Documentation pagination" className="flex items-center justify-between border-t pt-6 mt-6">
      <div>
        {prev && (
          <Link
            to={prev.url}
            className="group flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            <ChevronLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
            {prev.title}
          </Link>
        )}
      </div>
      <div>
        {next && (
          <Link
            to={next.url}
            className="group flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            {next.title}
            <ChevronRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        )}
      </div>
    </nav>
  )
}
